import useAxiosInterceptor from 'src/services/interceptor';
class MonthlyCloseoutService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMonthlyCloseOut = (payload: any) => {
    return this.axiosInstance.get(`/provider/month-end-alert/closeout`, {
      params: payload?.param,
    });
  };

  uploadSignatureFile = (payload: any) => {
    return this.axiosInstance.post(
      '/provider/month-end-alert/closeout/consent-upload',
      payload?.data,
      {
        params: payload?.param,
      }
    );
  };

  reopenCloseout = (payload: any) => {
    return this.axiosInstance.put('/provider/month-end-alert/closeout/reopen', null, {
      params: payload?.param,
    });
  };

  //  BOPS-115 — custom closeout periods. All three identify a period by its exact date range
  //  (there is no uuid on the wire), so an edit sends the current dates alongside the new ones.
  createCustomCloseout = (payload: any) => {
    return this.axiosInstance.post('/provider/month-end-alert/closeout/custom', null, {
      params: payload?.param,
    });
  };

  updateCustomCloseoutDates = (payload: any) => {
    return this.axiosInstance.put('/provider/month-end-alert/closeout/custom/dates', null, {
      params: payload?.param,
    });
  };

  cancelCustomCloseout = (payload: any) => {
    return this.axiosInstance.delete('/provider/month-end-alert/closeout/custom/cancel', {
      params: payload?.param,
    });
  };
}

const monthlyCloseoutService = new MonthlyCloseoutService();

Object.freeze(monthlyCloseoutService);

export default monthlyCloseoutService;
